// @noflow
import './sticky.component.css';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
import Stickyfill from 'stickyfill';

let stickyfill = null; // keep only one instance of stickyfill

export default class Sticky extends React.Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        className: PropTypes.string,
        top: PropTypes.string
    };

    static defaultProps = {
        className: '',
        top: '0rem'
    };

    componentDidMount() {
        if (stickyfill === null) {
            stickyfill = Stickyfill();
        }
        stickyfill.add(this.c);
    }

    componentDidUpdate() {
        stickyfill && stickyfill.rebuild();
    }

    componentWillUnmount() {
        stickyfill.remove(this.c);
    }

    render() {
        const { children, className, top } = this.props;

        return (
            <div className={classnames('sticky', className)} ref={c => (this.c = c)} style={{ top }}>
                {children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/sticky/sticky.component.js